export default {"src":"/_next/static/media/check.c8c90a9a.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};